import { slugify } from "../../utils/slugify.js";
import { Locale, type LocalizedString } from "../Locale.js";
import type { Product } from "../Product.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getProductPath(tenant: Tenant, product: Product): string {
	const pathMap: LocalizedString = {
		[Locale.cs]: `/${slugify(product.name[Locale.cs])}`,
	};

	return getPathInLocale(tenant.locale, pathMap);
}
